export default {
  "app": {
    "name": "DeepTrade",
    "tagline": "Trading de Criptomoedas com IA",
    "description": "Sinais de trading avançados e gestão automatizada de portfólio",
  },
  "navigation": {
    "dashboard": "Painel",
    "trading": "Trading",
    "signals": "Sinais",
    "apiCredentials": "Credenciais API",
    "autoTrading": "Trading Automático",
    "tierManagement": "Gestão de Níveis",
    "referrals": "Indicações",
    "accessSecurity": "Acesso e Segurança",
    "settings": "Configurações",
    "help": "Ajuda e Suporte",
    "login": "Entrar",
    "register": "Registrar",
    "logout": "Sair",
    "home": "Início",
  },
  "auth": {
    "layout": {
      "signInToAccount": "Entre na sua conta",
      "or": "Ou",
      "createNewAccount": "criar uma nova conta"
    },
    "login": {
      "title": "Bem-vindo de Volta",
      "subtitle": "Digite seu email e senha para entrar",
      "email": "Email",
      "password": "Senha",
      "emailPlaceholder": "nome@exemplo.com",
      "passwordPlaceholder": "••••••••",
      "rememberMe": "Lembrar de mim",
      "forgotPassword": "Esqueceu a senha?",
      "signIn": "Entrar",
      "noAccount": "Não tem uma conta?",
      "signUp": "Cadastrar-se",
      "googleSignIn": "Continuar com Google",
      "orContinueWith": "Ou continuar com",
      "fillAllFields": "Por favor, preencha todos os campos",
      "loginSuccess": "Login realizado com sucesso!",
      "loginFailed": "Falha no login",
      "loginFailedDescription": "Falha ao fazer login",
      "googleLoginFailed": "Falha ao iniciar login com Google",
      "bySigningIn": "Ao fazer login, você concorda com nossos",
      "termsOfService": "Termos de Serviço",
      "privacyPolicy": "Política de Privacidade",
      "and": "e"
    },
    "register": {
      "title": "Criar Conta",
      "subtitle": "Digite suas informações para criar uma conta",
      "firstName": "Nome",
      "lastName": "Sobrenome",
      "email": "Email",
      "password": "Senha",
      "confirmPassword": "Confirmar Senha",
      "agreeTerms": "Ao clicar em continuar, você concorda com nossos",
      "createAccount": "Criar conta",
      "hasAccount": "Já tem uma conta?",
      "signIn": "Entrar",
      "orContinueWith": "Ou continuar com",
      "googleSignUp": "Cadastrar-se com Google",
      "termsOfService": "Termos de Serviço",
      "privacyPolicy": "Política de Privacidade",
      "referralCode": "Código de Indicação (Opcional)",
      "placeholders": {
        "firstName": "João",
        "lastName": "Silva",
        "email": "nome@exemplo.com",
        "password": "Digite sua senha",
        "confirmPassword": "Confirme sua senha",
        "referralCode": "Digite código de indicação"
      },
      "validation": {
        "minLength": "A senha deve ter pelo menos 8 caracteres",
        "uppercase": "A senha deve conter pelo menos uma letra maiúscula",
        "lowercase": "A senha deve conter pelo menos uma letra minúscula",
        "number": "A senha deve conter pelo menos um número",
        "specialChar": "A senha deve conter pelo menos um caractere especial"
      },
      "errors": {
        "invalidReferralCode": "Código de indicação inválido",
        "referralValidationFailed": "Não foi possível validar o código de indicação. Verifique sua conexão e tente novamente.",
        "googleLoginFailed": "Falha ao iniciar login com Google",
        "googleLoginFailedTitle": "Falha no login com Google",
        "fillAllFields": "Por favor preencha todos os campos",
        "requirementsNotMet": "Requisitos de Senha Não Atendidos",
        "passwordsDoNotMatch": "As senhas não coincidem",
        "registrationFailed": "Falha no registro",
        "failedToCreateAccount": "Falha ao criar conta",
        "emailAlreadyRegistered": "Email já registrado",
        "emailAlreadyRegisteredDescription": "Uma conta com este endereço de email já existe. Tente fazer login.",
        "connectionError": "Erro de Conexão",
        "connectionErrorDescription": "Não foi possível conectar ao servidor. Verifique sua conexão e tente novamente.",
        "referralCodeError": "Erro no Código de Indicação",
        "referralCodeErrorDescription": "Houve um problema processando seu código de indicação. Sua conta ainda será criada.",
        "failedToResendEmail": "Falha ao reenviar email de verificação",
        "failedToResendEmailTitle": "Falha ao reenviar email",
        "tryAgainLater": "Tente novamente mais tarde."
      },
      "success": {
        "title": "Registro Bem-sucedido!",
        "description": "Verifique seu email para verificar sua conta."
      },
      "verification": {
        "title": "Verifique Seu Email",
        "description": "Enviamos um link de verificação para {{email}}",
        "nextSteps": "Próximos Passos:",
        "step1": "1. Verifique sua caixa de entrada",
        "step2": "2. Clique no link de verificação",
        "step3": "3. Retorne aqui para fazer login",
        "sending": "Enviando...",
        "resendButton": "Reenviar Email de Verificação",
        "backToLogin": "Voltar ao Login",
        "emailSentTitle": "Email de Verificação Enviado",
        "emailSentDescription": "Verifique seu email para o link de verificação."
      },
      "referral": {
        "validating": "Validando código de indicação...",
        "validCode": "Código de indicação válido de {{referrer}}"
      }
    },
    "passwordRequirements": {
      "title": "Requisitos de Senha",
      "length": "Pelo menos 8 caracteres",
      "uppercase": "Uma letra maiúscula",
      "lowercase": "Uma letra minúscula",
      "number": "Um número",
      "special": "Um caractere especial",
    },
    "errors": {
      "invalidCredentials": "Email ou senha inválidos",
      "emailRequired": "Email é obrigatório",
      "passwordRequired": "Senha é obrigatória",
      "passwordTooShort": "A senha deve ter pelo menos 8 caracteres",
      "passwordsNotMatch": "As senhas não coincidem",
      "emailInvalid": "Por favor, insira um endereço de email válido",
      "termsRequired": "Você deve concordar com os termos e condições",
    }
  },
  "dashboard": {
    "title": "Painel",
    "welcome": "Bem-vindo de volta!",
    "overview": "Visão Geral",
    "trading": "Trading",
    "tier": "Nível",
    "balance": "Saldo",
    "pnlToday": "Lucros e Perdas",
    "totalTrades": "Total de Negociações",
    "winRate": "Taxa de Vitória",
    "activeSignals": "Sinais Ativos",
    "tradingOverview": "Visão Geral do Trading",
    "quickActions": "Ações Rápidas",
    "viewSignals": "Ver Sinais",
    "autoTrading": "Trading Automático",
    "autoTradingDescription": "Executar sinais de trading automaticamente",
    "currentTier": "Nível Atual",
    "progressTo": "Progresso para o Nível {{tier},",
    "yourBenefits": "Seus Benefícios",
    "advancedSignals": "Sinais de Trading Avançados",
    "autoTradingFeatures": "Recursos de Trading Automático",
    "prioritySupport": "Suporte Prioritário",
    "monthlyRate": "Taxa Mensal",
    "currentMonthRate": "Este Mês",
    "monthlyAvgLabel": "Média Mensal",
    "symbolSelector": "Símbolo",
    "profitShare40": "40% participação nos lucros",
    "profitShare20": "20% participação nos lucros",
    "profitShare10": "10% participação nos lucros",
    "verifyingNFT": "Verificando propriedade do NFT...",
    "debt": "Dívida",
    "btcPrice": {
      "symbol": "BTC/USDT",
      "loading": "BTC/USDT: Carregando...",
      "unavailable": "BTC/USDT: --",
      "connecting": "Conectando...",
      "live": "Ao Vivo",
      "error": "Erro ({{count}})",
      "24h": "24h",
    },
    "controls": {
      "turnOn": "Ativar",
      "turnOff": "Desativar",
      "paperAutoTrading": "Trading Automático de Papel",
    },
    "forecast": {
      "title": "Previsão de Preços",
      "refresh": "Atualizar",
      "errorLoading": "Erro ao carregar gráfico",
      "retry": "Tentar novamente",
      "noData": "Nenhum dado de gráfico disponível",
    },
    "tradingChart": {
      "forecast": "Previsão",
      "upperBound": "Limite superior",
      "lowerBound": "Limite inferior",
      "support": "Suporte",
      "resistance": "Resistência",
      "entry": "Entrada",
      "stopLoss": "Stop loss",
      "takeProfit": "Take profit",
      "partialTakeProfit": "TP parcial",
      "liquidation": "Liquidação",
      "locked": "Bloqueado",
      "positionLevelDialogTitle": "Confirmar atualização de {{level}}",
      "positionLevelDialogDescription": "Definir {{level}} para {{symbol}} {{side}} de {{currentPrice}} para {{newPrice}}?",
      "positionLevelDelta": "Variação: {{delta}}%",
      "positionLevelConfirm": "Atualizar {{level}}",
      "positionLevelCancel": "Cancelar",
      "positionLevelProcessing": "Atualizando...",
      "positionLevelSuccess": "{{level}} atualizado",
      "positionLevelSuccessDesc": "{{symbol}} {{side}} · novo {{level}}: {{price}}",
      "positionLevelFailure": "Falha ao atualizar {{level}}",
      "positionLevelFailureDesc": "O nível anterior foi restaurado. {{error}}",
      "dragHint": "Arraste para mover · solte para confirmar",
      "indicators": {
        "title": "Indicadores",
        "overlays": "Sobreposições",
        "panes": "Painéis",
        "levels": "Níveis",
        "keyLevels": "Níveis-chave (S/R)",
        "reset": "Redefinir indicadores",
        "ema20": "EMA 20",
        "ema50": "EMA 50",
        "ema200": "EMA 200",
        "sma20": "SMA 20",
        "sma50": "SMA 50",
        "bb20": "Bandas de Bollinger (20, 2)",
        "bbUpper": "Bollinger superior",
        "bbMiddle": "Bollinger média",
        "bbLower": "Bollinger inferior",
        "vwap": "VWAP",
        "rsi14": "RSI (14)",
        "macd": "MACD (12, 26, 9)",
        "macdSignal": "Sinal MACD",
      },
      "drawing": {
        "toolbar": "Ferramentas de desenho",
        "select": "Selecionar",
        "magnetMode": "Ímã: {{mode}}",
        "stayInDrawingMode": "Manter modo de desenho",
        "hideAll": "Ocultar todos os desenhos",
        "showAll": "Mostrar todos os desenhos",
        "undo": "Desfazer",
        "redo": "Refazer",
        "deleteSelected": "Excluir desenhos selecionados",
        "clearAll": "Limpar todos os desenhos",
        "moreTools": "Mais ferramentas de desenho",
        "export": "Exportar desenhos",
        "import": "Importar desenhos",
        "textPrompt": "Digite o texto do desenho",
        "loadFailure": "Ferramentas de desenho indisponíveis",
        "importEmpty": "Nenhum desenho encontrado neste arquivo",
        "importSuccess": "{{count}} desenhos importados",
        "importFailure": "Falha ao importar desenhos",
        "clearConfirmTitle": "Limpar todos os desenhos?",
        "clearConfirmDescription": "Isso remove todos os desenhos do símbolo e período atuais. Não pode ser desfeito.",
        "categories": {
          "lines": "Linhas",
          "channels": "Canais",
          "fibonacci": "Fibonacci e Gann",
          "patterns": "Padrões",
          "elliott": "Elliott",
          "forecasting": "Previsão e medição",
          "volume": "Volume",
          "annotations": "Anotações",
          "shapes": "Formas",
          "cycles": "Ciclos",
          "regression": "Regressão",
        },
        "tools": {
          "trend-line": "Linha de tendência",
          "horizontal-line": "Linha horizontal",
          "vertical-line": "Linha vertical",
          "ray": "Raio",
          "parallel-channel": "Canal paralelo",
          "fib-retracement": "Retração de Fib",
          "trend-based-fib-extension": "Extensão de Fib por tendência",
          "rectangle": "Retângulo",
          "text": "Texto",
          "arrow": "Seta",
          "brush": "Pincel",
          "price-range": "Intervalo de preço",
          "long-position": "Posição comprada",
          "short-position": "Posição vendida",
        },
      },
    },
    "realTimePerformance": "Desempenho em Tempo Real",
    "riskSettings": {
      "title": "Configurações de Gerenciamento de Risco",
      "paperTradingTitle": "Configurações de Gestão de Risco - Trading de Simulação",
      "loading": "Carregando configurações de risco...",
      "investmentPercentage": "Porcentagem de Investimento",
      "investmentDescription": "Porcentagem do saldo a usar para trading (0% - 10%)",
      "leverage": "Alavancagem",
      "leverageDescription": "Máx: {{max}}x para Nível {{tier}} + {{exchange}} {{market},",
      "paperTradingLeverageDesc": "No modo simulação, você pode usar qualquer configuração de alavancagem para testes",
      "exchange": "Exchange: ",
      "configureCredentials": "Configurar em Credenciais da API",
      "warningZeroInvestment": "Selecione porcentagem de investimento > 0% para habilitar trading",
      "paperTradingNote": "Modo trading de simulação - não se aplicam limitações de nível",
      "saveSettings": "Salvar Configurações",
      "saving": "Salvando...",
      "resetToSafe": "Redefinir para Seguro",
      "confirmSaveTitle": "Confirmar Configurações de Risco",
      "confirmSaveDesc": "Tem certeza de que deseja salvar essas configurações de risco?\n\nInvestimento: {{investment}}%\nAlavancagem: {{leverage}}x\nModo: {{mode}}",
      "confirmSave": "Salvar Configurações",
      "saveSuccess": "Configurações Salvas",
      "saveSuccessDesc": "Suas configurações de gerenciamento de risco foram salvas com sucesso.",
      "saveError": "Falha ao Salvar",
      "tradingStrategy": "Estratégia de Trading",
      "strategyActive": "Estratégia Padrão",
      "strategyConservative": "Estratégia Neural AI",
      "strategyActiveBadge": "Recomendado",
      "strategyActiveDesc": "Negociações mais frequentes baseadas em previsões de preços com ML. Gera 3-8 sinais por dia com 75-80% de precisão esperada. Ideal para traders que querem mais oportunidades e conseguem lidar com atividade moderada.",
      "strategyConservativeDesc": "Menos negociações, porém com maior confiança e confirmações rigorosas. Gera 1-3 sinais por dia com 85-90% de precisão esperada. Ideal para traders conservadores que preferem qualidade em vez de quantidade.",
      "gridTradingTitle": "Grid Trading",
      "gridEnabledLabel": "Ativar Grid Trading",
      "trailingStopTitle": "Trailing Stop",
      "trailingStopEnabledLabel": "Ativar Trailing Stop",
      "tradingSymbolsLabel": "Símbolos de Negociação",
      "tradingSymbolsHint": "Apenas símbolos marcados operam automaticamente",
      "tradingSymbolsEmptyWarning": "Nenhum símbolo selecionado: o auto-trading não abrirá negociações para esta conta.",
      "signalsPerDay": "Sinais por Dia",
      "expectedAccuracy": "Precisão Esperada",
      "tradeFrequency": "Frequência de Trading",
      "riskLevel": "Nível de Risco",
      "profitPotential": "Potencial de Lucro",
      "bestFor": "Melhor Para",
      "activeTraders": "Traders ativos que querem mais oportunidades",
      "conservativeTraders": "Traders conservadores que preferem qualidade sobre quantidade",
      "high": "Alto",
      "low": "Baixo",
      "moderate": "Moderado",
      "higher": "Maior",
      "viewComparison": "Ver Comparação",
      "hideComparison": "Ocultar Comparação",
      "testForecastStrategy": "Testar Estratégia de Previsão",
      "testingStrategy": "Testando Estratégia...",
      "testStrategyDesc": "Clique para testar se a estratégia de previsão abriria uma negociação agora",
      "paperSettingsError": "Erro de Configurações de Papel",
      "paperSettingsErrorDesc": "Falha ao carregar as configurações de risco do trading de papel.",
      "settingsLoadError": "Erro de Carregamento de Configurações",
      "settingsLoadErrorDesc": "Falha ao carregar as configurações de risco. Por favor, atualize a página.",
      "configurationRequired": "Configuração Necessária",
      "configurationRequiredDesc": "Por favor, defina a porcentagem de investimento acima de 0% antes de testar a estratégia.",
      "noTradeSignal": "Sem Sinal de Trading",
      "noTradeSignalDesc": "A previsão mostra movimento insuficiente. Ascendente: {{upward}}%, Descendente: {{downward}}%. Necessário >0.5% para ativar o trading.",
      "strategyTestSuccessful": "Teste de Estratégia Bem-sucedido",
      "strategyTestSuccessfulDesc": "Sinal {{direction}} detectado com {{movement}}% de movimento potencial. {{result}}",
      "paperTradeOpened": "Negociação de papel aberta com sucesso!",
      "tradeSimulationCompleted": "Simulação de negociação concluída.",
      "strategyTestFailed": "Teste de Estratégia Falhou",
      "strategyTestFailedDesc": "Erro desconhecido ocorreu durante o teste de estratégia.",
      "strategyTestError": "Erro de Teste de Estratégia",
      "strategyTestErrorDesc": "Falha ao testar a estratégia de previsão.",
    },
    "activePositions": {
      "title": "Posições Ativas",
      "tabs": {
        "all": "todas",
        "app": "app",
        "external": "externas",
      },
      "refresh": "Atualizar",
      "errorLoading": "Erro ao carregar posições ativas",
      "retry": "Tentar Novamente",
      "noPositions": "Nenhuma posição ativa.",
      "noPositionsDesc": "Suas posições de trading ativas aparecerão aqui assim que você começar a negociar ou ativar o auto-trading.",
      "noAppPositions": "Nenhuma posição ativa do app.",
      "noExternalPositions": "Nenhuma posição externa ativa.",
      "addCredentialsWarning": " Adicione credenciais da API para ver posições externas",
      "externalError": "❌ Erro nas posições externas: {{error},",
      "externalErrorGeneric": "❌ {{error},",
      "diagnostics": "App: {{app}} | Externas: {{external},",
      "fields": {
        "size": "Tamanho",
        "entryPrice": "Preço de Entrada",
        "currentPrice": "Preço Atual",
        "margin": "Margem",
        "liquidationPrice": "Preço Liq.",
        "marginRate": "Taxa de Margem",
        "takeProfit": "TP",
        "stopLoss": "SL",
        "roi": "ROE",
        "none": "Nenhum",
        "na": "N/A",
      },
      "positionTypes": {
        "appPositions": "Posições do App",
        "externalPositions": "Posições Externas",
      },
      "exposureWarningTitle": "Exposicao da exchange detectada",
      "exposureWarningMixedDesc": "O DeepTrade detectou posicoes externas da exchange junto com operacoes gerenciadas pelo app. Revise os totais da aba All na exchange antes de habilitar o auto-trading.",
      "exposureWarningExternalOnlyDesc": "O DeepTrade detectou posicoes externas da exchange que nao sao gerenciadas pelo app. Revise sua exposicao na exchange antes de habilitar o auto-trading.",
      "headers": {
        "symbol": "Símbolo",
        "size": "Tamanho",
        "entryPrice": "Preço de Entrada",
        "markPrice": "Preço de Marca",
        "liqPrice": "Preço de Liq.",
        "margin": "Margem",
        "pnlRoi": "PNL (ROE %)",
        "tpSl": "TP/SL",
        "actions": "Ações",
      },
      "close": "Fechar",
      "closing": "Fechando...",
      "featureNotAvailable": "Recurso Não Disponível",
      "positionClosingPaperOnly": "O fechamento de posições atualmente está disponível apenas no modo de Trading de Papel.",
      "tpSlPaperOnly": "TP/SL atualmente está disponível apenas no modo de Trading de Papel.",
      "positionClosed": "Posição Fechada",
      "positionClosedDesc": "Posição fechada com sucesso. PnL: ${{pnl}}",
      "errorClosingPosition": "Erro ao Fechar Posição",
      "errorClosingPositionDesc": "Falha ao fechar a posição",
      "takeProfitSet": "Take Profit Definido",
      "takeProfitSetDesc": "Take profit definido em ${{price}}",
      "errorSettingTakeProfit": "Erro ao Definir Take Profit",
      "errorSettingTakeProfitDesc": "Falha ao definir Take Profit",
      "stopLossSet": "Stop Loss Definido",
      "stopLossSetDesc": "Stop loss definido em ${{price}}",
      "errorSettingStopLoss": "Erro ao Definir Stop Loss",
      "errorSettingStopLossDesc": "Falha ao definir Stop Loss",
      "position": "posição",
      "positions": "posições",
      "allPositions": "Todas as Posições",
      "noApiCredentials": "Nenhuma credencial API conectada",
    },
    "debug": {
      "testSuccessful": "Teste de Trading Debug Bem-sucedido",
      "paperTradeOpened": "Negociação de papel aberta com sucesso!",
      "tradeSimulationCompleted": "Simulação de negociação concluída.",
      "testFailed": "Teste de Trading Debug Falhou",
      "unknownError": "Erro desconhecido ocorreu durante o teste de trading debug.",
      "testError": "Erro de Teste Debug",
      "testErrorDesc": "Falha ao testar a abertura de negociação.",
    },
    "profitShare": {
      "title": "Rastreamento de Participação nos Lucros",
      "loading": "Carregando dados de participação nos lucros...",
      "noData": "Nenhum dado de participação nos lucros disponível. Comece a negociar para rastrear seus lucros.",
      "balanceOverview": "Visão Geral do Saldo",
      "initialBalance": "Saldo Inicial:",
      "currentBalance": "Saldo Atual:",
      "netDeposits": "Depósitos Líquidos:",
      "profitAnalysis": "Análise de Lucros",
      "tradingProfit": "Lucro do Trading:",
      "trueProfit": "Lucro Real:",
      "profitPercentage": "% de Lucro:",
      "profitShareInfo": "Participação nos Lucros",
      "tierRate": "Taxa do Nível {{tier}}:",
      "amountOwed": "Valor Devido:",
      "status": "Status:",
      "profitable": "A conta está lucrativa - A participação nos lucros se aplica aos ganhos acima do saldo inicial",
      "notProfitable": "A conta ainda não é lucrativa - Sem participação nos lucros até que o saldo exceda o inicial + depósitos",
      "profitableDescription": "Seu saldo está acima do capital inicial e dos depósitos. As taxas de participação nos lucros serão calculadas sobre os ganhos mostrados acima.",
      "notProfitableDescription": "Continue negociando para superar seu capital inicial mais depósitos. Até lá, nenhuma participação nos lucros será devida.",
      "paymentRequired": "Pagamento Necessário",
      "paymentDescription": "Você tem ${{amount}} em taxas de participação nos lucros para pagar.",
      "payNow": "Pagar Agora",
      "viewDetails": "Ver detalhes da participação",
    },
    "tradingHistory": {
      "title": "Histórico de Trading (Apenas Trades da App)",
      "description": "Mostrando trades iniciados pela plataforma DeepTrade",
      "loading": "Carregando...",
      "errorTitle": "Não foi possível carregar o histórico de trading",
      "errorMessage": "Não conseguimos recuperar o seu histórico de trading ao vivo. Tente novamente ou verifique suas credenciais de exchange antes de atualizar.",
      "headers": {
        "date": "Data",
        "symbol": "Símbolo",
        "side": "Direção",
        "size": "Tamanho",
        "entry": "Entrada",
        "exit": "Saída",
        "fees": "Taxas",
        "pnl": "P&L Bruto",
        "status": "Status",
      },
      "noHistory": "Nenhum histórico de trading encontrado. Comece a negociar para ver seu histórico aqui.",
      "pagination": "Página {{page}} de {{pages}} ({{total}} negociações totais)",
      "previous": "Anterior",
      "next": "Próximo",
    },
    "blockedUser": {
      "title": "Trading Bloqueado:",
      "message": "Participação nos lucros não paga para seu nível ({{tier}}). Devido: ${{owed}}. Por favor, quite seu saldo para continuar.",
    },
    "tooltips": {
      "balance": "Seu saldo de conta atual da sua exchange conectada.",
      "pnlToday": "Lucro e perda realizados de negociações fechadas hoje.",
      "monthlyRate": "Sua taxa de retorno mensual como porcentagem.",
      "currentMonthRate": "Lucro realizado do mês calendário atual (até o momento), como porcentagem do seu saldo no início do mês.",
      "monthlyAvgRate": "Lucro mensal médio dos meses completos desde sua primeira negociação.",
      "symbolSelector": "Alterna o gráfico de previsão de preços e o ticker de preço do cabeçalho entre os pares oferecidos.",
      "winRate": "Porcentagem de suas negociações que foram lucrativas."
    }
  },
  "performanceAnalytics": {
    "title": "Análises de Desempenho",
    "paperMode": "Simulação",
    "liveMode": "Real",
    "refresh": "Atualizar dados de desempenho",
    "noTrades": "Ainda não há negociações fechadas: as análises aparecerão após o fechamento da primeira negociação.",
    "viewCumulative": "Acumulado",
    "viewMonthly": "Mensal",
    "viewStatistics": "Estatísticas",
    "groupReturns": "Retornos",
    "groupRisk": "Risco",
    "groupTrades": "Negociações",
    "expectancyUsd": "Expectativa",
    "expectancyR": "Expectativa (R)",
    "profitFactor": "Fator de Lucro",
    "maxDrawdownPct": "DD Máx %",
    "drawdownDuration": "Duração DD",
    "recoveryFactor": "Fator de Recuperação",
    "sharpe": "Sharpe",
    "sortino": "Sortino",
    "avgWin": "Ganho Médio",
    "avgLoss": "Perda Média",
    "maxConsecWins": "Vitórias Consec.",
    "maxConsecLosses": "Derrotas Consec.",
    "bestTrade": "Melhor Negociação",
    "worstTrade": "Pior Negociação",
    "avgDuration": "Duração Média",
    "feesPaid": "Taxas Pagas",
    "exitReasonsTitle": "Motivos de Saída",
    "rDistribution": "Distribuição de Múltiplos R",
    "daysUnit": "d",
    "hoursUnit": "h",
    "range7d": "7D",
    "range30d": "30D",
    "rangeYtd": "YTD",
    "range1y": "1A",
    "rangeAll": "Tudo",
    "sideBySide": "Drawdown abaixo do lucro",
    "cumulativeProfit": "Lucro Acumulado",
    "drawdown": "Drawdown",
    "monthlyPnl": "P&L Mensal",
    "monthlyAvg": "Média Mensal",
    "profitUsd": "Lucro (USD)",
    "drawdownUsd": "Drawdown (USD)",
    "totalPnl": "P&L Total",
    "currentMonth": "Este Mês",
    "maxDrawdown": "Drawdown Máximo",
    "winRate": "Taxa de Acerto",
    "totalTrades": "Negociações",
    "bySymbol": "Por Símbolo",
    "symbol": "Símbolo",
    "pnl": "P&L",
    "trades": "Negociações"
  },
  "trading": {
    "title": "Trading",
    "signals": "Sinais",
    "positions": "Posições",
    "history": "Histórico",
    "long": "Longo",
    "short": "Curto",
    "autoTrading": "Trading Automático",
    "autoTradingActive": "Trading Automático Ativo",
    "autoTradingDisabled": "Trading Automático Desabilitado",
    "autoTradingActiveDesc": "Sinais serão executados automaticamente",
    "autoTradingDisabledDesc": "Habilite para executar sinais de trading automaticamente",
    "noActiveSignals": "Nenhum Sinal Ativo",
    "waitingForSignals": "Aguardando novas oportunidades de trading...",
    "enableAutoTrading": "Habilite o auto trading para receber sinais",
    "refreshSignals": "Atualizar Sinais",
    "noOpenPositions": "Nenhuma Posição Aberta",
    "positionsDesc": "Suas posições de trading ativas aparecerão aqui",
    "noTradingHistory": "Nenhum Histórico de Trading",
    "historyDesc": "Suas negociações concluídas aparecerão aqui",
    "executeTradeButton": "Executar Negociação",
    "viewDetailsButton": "Ver Detalhes",
    "entry": "Entrada",
    "stopLoss": "Stop Loss",
    "takeProfit": "Take Profit",
    "confidence": "{{value}}% confiança",
    "strategy": "Estratégia",
    "firstTp": "Primeiro TP",
    "secondTp": "Segundo TP",
    "autoMoveStopLoss": "Mover SL automaticamente para breakeven após primeiro TP",
    "tradingMode": "Modo de Trading",
    "paperMode": "Simulação",
    "liveMode": "Ao Vivo",
    "paperTradingActive": "Trading de Simulação Ativo",
    "liveTradingActive": "Trading Ao Vivo Ativo",
    "paperTradingDesc": "Pratique trading com fundos virtuais",
    "liveTradingDesc": "Negocie com dinheiro real",
    "virtualBalance": "Saldo Virtual",
    "unrealizedPnL": "P&L Não Realizado",
    "equity": "Patrimônio",
    "paperTradingHelp": "Ajuda do Trading de Simulação",
    "resetAccount": "Redefinir Conta",
    "paperTradingGuide": "Guia do Trading de Simulação",
    "paperModeTitle": "Modo Simulação",
    "noProfitSharePaper": "Sem participação nos lucros no modo simulação",
    "paperTradingPositions": "Total de Posições:",
    "paperTradingHistory": "Histórico do Trading de Simulação",
    "simulatedTradingHistory": "Histórico de trading simulado",
    "noPaperPositions": "Nenhuma posição de trading de simulação",
    "enableAutoTradingPaper": "O trading de simulação gerará automaticamente posições simuladas baseadas em sinais do mercado",
    "paperTradingMode": "Modo Trading de Simulação",
    "autoTradingNotAvailable": "Trading Automático Não Disponível",
    "autoTradingDisabledPaper": "O trading automático controla o trading ao vivo. O trading de simulação gera sinais automaticamente.",
    "riskManagement": "Gestão de Risco",
    "riskSettings": "Configurações de Risco",
    "investmentPercentage": "Porcentagem de Investimento",
    "leverage": "Alavancagem",
    "maxLeverage": "Alavancagem Máxima",
    "currentTier": "Nível Atual",
    "exchange": "Exchange",
    "accountType": "Tipo de Conta",
    "marketType": "Tipo de Mercado",
    "saveSettings": "Salvar Configurações",
    "resetToSafe": "Redefinir para Seguro",
    "saving": "Salvando...",
    "riskSettingsSaved": "Configurações de risco salvas com sucesso",
    "failedToSaveRiskSettings": "Falha ao salvar configurações de risco",
    "position": "posição",
    "internal": "Interno",
    "external": "Externo",
    "marketClose": "Fechar MKT",
    "reverse": "Reverter",
    "editTpSl": "TP/SL",
    "refreshActivePositions": "Atualizar Posições Ativas",
    "youHaveNoPosition": "Você não tem posições.",
    "noActiveAppPositions": "Nenhuma posição ativa do app encontrada.",
    "noActiveExternalPositions": "Nenhuma posição externa ativa encontrada.",
    "yourActivePositionsWillAppear": "Suas posições de trading ativas aparecerão aqui.",
    "previous": "Anterior",
    "next": "Próximo",
    "learnMore": "Saiba Mais",
    "paperTradingLabel": "Trading de Simulação",
    "recentPaperTrades": "Negociações de Simulação Recentes",
    "noPaperTrades": "Ainda não há negociações de simulação",
    "paperTradingAutoGenerate": "O trading de simulação gerará automaticamente negociações simuladas baseadas em sinais do mercado",
    "activePositionsTitle": "Posições Ativas",
    "youHaveNoPositions": "Você não tem posições.",
    "yourActivePositionsWillAppearHere": "Suas posições de trading ativas aparecerão aqui assim que você começar a negociar ou habilitar o trading automático.",
    "max": "Máx",
    "tooltips": {
      "virtualBalance": "Seu saldo realizado de negociações fechadas. Calculado como: Saldo Inicial + P&L Líquido Total de todas as negociações fechadas.",
      "unrealizedPnL": "Lucro ou perda de suas posições atualmente abertas. Este valor muda em tempo real com base nos preços atuais do mercado e ainda não foi realizado.",
      "equity": "O valor total de sua conta incluindo posições abertas. Calculado como: Saldo Virtual + P&L Não Realizado. Isso representa seu patrimônio líquido atual no trading de simulação.",
      "profitAndLoss": "Lucro e perda realizados apenas de negociações fechadas. Isso não inclui o P&L não realizado de posições abertas.",
      "balance": "Seu saldo de conta atual disponível para negociação.",
      "pnlToday": "Lucro e perda realizados de negociações fechadas hoje.",
      "monthlyRate": "Sua taxa de retorno mensal calculada como porcentagem do seu saldo inicial.",
      "winRate": "Porcentagem de negociações fechadas que foram lucrativas. Calculado apenas de negociações concluídas.",
      "totalReturn": "Sua porcentagem de retorno total baseada no Saldo Virtual. Calculado como: (Saldo Virtual Atual - Saldo Inicial) / Saldo Inicial × 100%."
    }
  },
  "common": {
    "loading": "Carregando...",
    "error": "Erro",
    "success": "Sucesso",
    "save": "Salvar",
    "cancel": "Cancelar",
    "yes": "Sim",
    "no": "Não",
    "active": "Ativo",
    "inactive": "Inativo",
    "on": "LIGADO",
    "off": "DESLIGADO",
    "enabled": "habilitado",
    "disabled": "desabilitado",
    "for": "para",
    "warning": "Warning",
    "info": "Informação",
    "confirm": "Confirmar",
    "edit": "Edit",
    "delete": "Delete",
    "close": "Fechar",
    "back": "Voltar",
    "next": "Próximo",
    "previous": "Anterior",
    "submit": "Submit",
    "reset": "Reset",
    "search": "Search",
    "filter": "Filter",
    "sort": "Sort",
    "refresh": "Refresh",
    "enable": "Habilitar",
    "disable": "Desabilitar",
    "toggleOn": "ON",
    "toggleOff": "OFF",
    "ok": "OK",
    "apply": "Aplicar",
    "clear": "Limpar",
    "select": "Selecionar",
    "upload": "Enviar",
    "download": "Baixar",
    "copy": "Copiar",
    "copied": "Copiado!",
    "share": "Share",
    "print": "Imprimir",
    "export": "Export",
    "import": "Import",
    "and": "e",  },
  "wallet": {
    "connect": "Conectar Carteira",
    "disconnect": "Desconectar",
    "connected": "Conectado",
    "notConnected": "Não Conectado",
    "connecting": "Conectando...",
    "balance": "Saldo",
    "address": "Endereço",
    "solanaBlockchain": "Alimentado por Blockchain Solana",
    "solanaTooltip": "Construído em Solana - Blockchain rápida, segura e escalável",
    "wrongNetwork": "Rede Incorreta",
    "switchNetwork": "Trocar Rede",
    "transactionPending": "Transação Pendente",
    "transactionConfirmed": "Transação Confirmada",
    "transactionFailed": "Transação Falhada",
    "connectionError": "Erro de Conexão",
    "connectionFailed": "Falha ao conectar carteira",
    "connectionRejected": "A conexão da carteira foi rejeitada",
    "walletNotFound": "Nenhuma carteira Solana encontrada. Por favor instale uma carteira como Phantom.",
    "disconnected": "Carteira Desconectada",
    "disconnectedSuccess": "Sua carteira foi desconectada com sucesso.",
    "disconnectError": "Erro de Desconexão",
    "disconnectFailed": "Falha ao desconectar carteira.",
    "confirmDisconnect": "Confirmar Desconexão da Carteira",
    "confirmDisconnectMessage": "Tem certeza de que deseja desconectar sua carteira?",
  },
  "notifications": {
    "autoTradingEnabled": "Auto-trading foi habilitado",
    "autoTradingDisabled": "Auto-trading foi desabilitado",
    "settingsSaved": "Configurações salvas com sucesso",
    "passwordChanged": "Senha alterada com sucesso",
    "profileUpdated": "Perfil atualizado com sucesso",
    "walletConnected": "Carteira conectada com sucesso",
    "walletDisconnected": "Carteira desconectada",
    "signalExecuted": "Sinal de trading executado",
    "tradeCompleted": "Negociação concluída com sucesso",
    "paymentSuccessful": "Pagamento processado com sucesso",
    "tierUpgraded": "Nível atualizado com sucesso",
    "autoTrading": {
      "enabledTitle": "Trading Automático Habilitado",
      "enabledDescription": "O trading automático foi habilitado com sucesso. Requisito de saldo verificado.",
      "disabledTitle": "Trading Automático Desabilitado",
      "disabledDescription": "O trading automático foi desabilitado com sucesso.",
      "insufficientBalanceTitle": "Saldo Insuficiente",
      "insufficientBalanceDescription": "Saldo mínimo de {{required}} USDT necessário. Seu saldo atual é {{current}} USDT.",
      "missingCredentialsTitle": "Credenciais da API Ausentes",
      "missingCredentialsDescription": "Por favor, adicione e valide suas credenciais da API do exchange primeiro.",
      "balanceVerificationFailedTitle": "Verificação de Saldo Falhada",
      "balanceVerificationFailedDescription": "Falha ao verificar o saldo da conta. Por favor, verifique suas credenciais da API.",
      "errorTitle": "Erro no Trading Automático",
      "errorDescription": "Falha ao alternar o trading automático. Por favor, tente novamente.",
      "systemDisabledTitle": "Trading Automático Desabilitado",
      "noApiCredentialsReason": "Nenhuma credencial API do exchange configurada. Por favor, adicione suas chaves API.",
      "investmentPercentageReason": "A porcentagem de investimento está definida como 0%. Por favor, ajuste suas configurações de risco.",
    },
    "paperAutoTrading": {
      "enabledTitle": "Trading Automático de Papel Habilitado",
      "enabledDescription": "Os sinais de trading de papel agora serão executados automaticamente",
      "disabledTitle": "Trading Automático de Papel Desabilitado",
      "disabledDescription": "Os sinais de trading de papel não serão mais executados automaticamente",
      "errorTitle": "Erro no Trading Automático de Papel",
      "errorDescription": "Falha ao alternar o trading automático de papel"
    }
  },
  "pagination": {
    "show": "Mostrar",
    "perPage": "por página",
    "showing": "Mostrando {{start}} a {{end}} de {{total}} registros",
    "previous": "Anterior",
    "next": "Próximo"
  },
  "errors": {
    "generic": "Algo deu errado. Por favor tente novamente.",
    "network": "Erro de rede. Por favor verifique sua conexão.",
    "unauthorized": "Você não está autorizado a realizar esta ação.",
    "forbidden": "Acesso negado.",
    "notFound": "O recurso solicitado não foi encontrado.",
    "serverError": "Erro do servidor. Por favor tente mais tarde.",
    "validationError": "Por favor verifique sua entrada e tente novamente.",
    "walletNotConnected": "Por favor conecte sua carteira primeiro.",
    "insufficientBalance": "Saldo insuficiente.",
    "transactionFailed": "Transação falhada. Por favor tente novamente.",
    "apiError": "Erro de API. Contate o suporte se isso persistir.",
  },
  "settings": {
    "title": "Configurações de Conta",
    "pleaseLogIn": "Por Favor Faça Login",
    "loginRequired": "Você precisa estar logado para acessar as configurações da conta.",
    "goToLogin": "Ir para Login",
    "profile": {
      "title": "Configurações de Perfil",
      "description": "Gerencie as informações e preferências da sua conta",
      "email": "Endereço de Email",
      "currentEmail": "Email Atual",
      "newEmail": "Novo Endereço de Email",
      "updateEmail": "Atualizar Email",
      "sending": "Enviando...",
      "placeholders": {
        "newEmail": "Digite seu novo endereço de email",
        "currentPassword": "Digite sua senha atual"
      }
    },
    "security": {
      "title": "Configurações de Segurança",
      "description": "Gerencie sua senha e preferências de segurança",
      "changePassword": "Alterar Senha",
      "currentPassword": "Senha Atual",
      "newPassword": "Nova Senha",
      "confirmPassword": "Confirmar Nova Senha",
      "enable2FA": "Autenticação de Dois Fatores",
      "twoFactorEnabled": "A autenticação de dois fatores está habilitada para sua conta",
      "twoFactorDisabled": "A autenticação de dois fatores está desabilitada para sua conta",
      "changing": "Alterando...",
      "changePasswordButton": "Alterar Senha",
      "verificationCode": "Código de Verificação",
      "verifyCode": "Verificar Código",
      "verifying": "Verificando...",
      "cancel": "Cancelar",
      "disable2FA": "Desabilitar Autenticação de Dois Fatores",
      "disable2FADescription": "Tem certeza de que deseja desabilitar 2FA? Isso tornará sua conta menos segura. Enviaremos um código de verificação para seu email para confirmar esta ação.",
      "sendVerificationCode": "Enviar Código de Verificação",
      "disabling": "Desabilitando...",
      "disable2FAButton": "Desabilitar 2FA",
      "resendCode": "Reenviar Código",
      "verifyEmail": "Verifique Seu Email",
      "verifyEmailDescription": "Enviamos um código de verificação de 6 dígitos para seu email. Digite-o abaixo para habilitar 2FA.",
      "verifyEmailToDisable2FA": "Verifique Email para Desabilitar 2FA",
      "verifyEmailToDisable2FADescription": "Enviamos um código de verificação de 6 dígitos para seu email. Digite-o abaixo para desabilitar a autenticação de dois fatores.",
      "placeholders": {
        "currentPassword": "Digite sua senha atual",
        "newPassword": "Digite sua nova senha",
        "confirmPassword": "Confirme sua nova senha",
        "verificationCode": "Digite código de 6 dígitos"
      }
    },
    "account": {
      "title": "Zona de Perigo",
      "deleteAccount": "Excluir Conta",
      "deleteAccountWarning": "Uma vez que você exclua sua conta, não há volta. Por favor, tenha certeza.",
      "deleteAccountButton": "Excluir Conta",
      "deleting": "Excluindo...",
      "deleteAccountModal": {
        "title": "Excluir Conta",
        "description": "Esta ação não pode ser desfeita. Isso excluirá permanentemente sua conta e removerá todos os dados associados.",
        "confirmText": "Excluir Conta",
        "typedConfirmationText": "EXCLUIR",
        "permanentlyDelete": "Isso excluirá permanentemente:",
        "consequences": [
          "Excluir todos os seus dados permanentemente",
          "Remover seu histórico de trading",
          "Cancelar assinaturas ativas",
          "Remover todas as credenciais API",
          "Excluir todas as configurações e preferências"
        ]
      }
    },
    "errors": {
      "fillAllFields": "Por favor, preencha todos os campos",
      "passwordsNotMatch": "As novas senhas não coincidem",
      "invalidVerificationCode": "Por favor, digite o código de verificação",
      "invalid6DigitCode": "Por favor, digite um código de verificação válido de 6 dígitos",
      "updateEmailFailed": "Falha ao atualizar email",
      "changePasswordFailed": "Falha ao alterar senha",
      "enable2FAFailed": "Falha ao habilitar 2FA",
      "verify2FAFailed": "Falha ao verificar código 2FA",
      "disable2FAFailed": "Falha ao enviar código de verificação para desabilitar",
      "disable2FAVerifyFailed": "Falha ao desabilitar 2FA",
      "deleteAccountFailed": "Falha ao excluir conta"
    },
    "success": {
      "verificationEmailSent": "Email de Verificação Enviado",
      "verificationEmailDescription": "Por favor, verifique {{email}} para instruções de verificação.",
      "passwordChanged": "Senha Alterada",
      "passwordChangedDescription": "Sua senha foi atualizada com sucesso.",
      "2FACodeSent": "Código 2FA Enviado",
      "2FACodeSentDescription": "Por favor, verifique seu email para o código de verificação.",
      "2FAEnabled": "2FA Habilitado",
      "2FAEnabledDescription": "A autenticação de dois fatores foi habilitada com sucesso.",
      "verificationCodeSent": "Código de Verificação Enviado",
      "verificationCodeSentDescription": "Por favor, verifique seu email para o código de verificação de 6 dígitos para desabilitar 2FA.",
      "2FADisabled": "2FA Desabilitado",
      "2FADisabledDescription": "A autenticação de dois fatores foi desabilitada com sucesso.",
      "accountDeleted": "Conta Excluída",
      "accountDeletedDescription": "Sua conta foi excluída com sucesso."
    }
  },
  "accessSecurity": {
    "title": "Acesso e Segurança",
    "subtitle": "Monitore a segurança da sua conta e atividade de login",
    "totalLogins": "Total de Logins",
    "successRate": "Taxa de Sucesso",
    "uniqueIPs": "IPs Únicos",
    "twoFactorStatus": "Status 2FA",
    "enabled": "Habilitado",
    "disabled": "Desabilitado",
    "currentSession": "Sessão Atual",
    "currentSessionDescription": "Informações sobre sua sessão de login atual",
    "recentLoginActivity": "Atividade de Login Recente",
    "recentLoginDescription": "Suas tentativas de login e sessões recentes",
    "refresh": "Atualizar",
    "ipAddress": "Endereço IP",
    "timestamp": "Timestamp",
    "status": "Status",
    "userAgent": "User Agent",
    "successful": "Bem-sucedido",
    "failed": "Falhado",
    "noLoginActivity": "Nenhuma atividade de login encontrada",
    "currentDevice": "Dispositivo Atual",
    "location": "Localização",
    "sessionStart": "Início da Sessão",
    "lastLoginActivity": "Última Atividade de Login",
    "lastLoginDescription": "Seu último login bem-sucedido",
    "loginTime": "Hora do Login",
    "browser": "Navegador",
    "lastThirtyDays": "Últimos 30 dias",
    "loginSuccessRate": "Taxa de sucesso de login",
    "differentLocations": "Localizações diferentes",
    "never": "Nunca",
    "unknown": "Desconhecido",
    "reason": "Motivo:",
    "authenticationRequired": "Autenticação Necessária",
    "authenticationRequiredDescription": "Por favor, faça login para ver suas informações de segurança.",
    "errors": {
      "authenticationError": "Erro de Autenticação",
      "authenticationErrorDescription": "Por favor, faça login novamente para ver os dados de segurança.",
      "networkError": "Erro de Rede",
      "networkErrorDescription": "Falha ao buscar dados de segurança. Por favor, verifique sua conexão.",
      "refreshFailed": "Falha na atualização",
      "refreshFailedDescription": "Falha ao atualizar dados de segurança. Por favor, tente novamente."
    },
    "success": {
      "dataRefreshed": "Dados de segurança atualizados",
      "dataRefreshedDescription": "Suas informações de segurança foram atualizadas com sucesso."
    }
  },
  "tiers": {
    "title": "Gestão de Níveis",
    "currentTier": "Nível Atual",
    "choosePlan": "Escolha Seu Plano",
    "tier1": {
      "name": "Nível 1",
      "subtitle": "Grátis",
      "description": "Perfeito para começar com sinais básicos de trading",
      "features": [
        "Sinais básicos de trading",
        "Execução manual de negociações",
        "Suporte da comunidade",
        "Análise básica do mercado"
      ]
    },
    "tier2": {
      "name": "Nível 2",
      "subtitle": "Acesso por 30 dias",
      "description": "Recursos avançados para traders sérios",
      "features": [
        "Sinais avançados de trading com IA",
        "Capacidades de auto-trading",
        "Suporte prioritário",
        "Análise avançada",
        "Ferramentas de gestão de risco"
      ]
    },
    "tier3": {
      "name": "Nível 3",
      "subtitle": "NFT Necessário",
      "description": "Nível premium com recursos exclusivos",
      "features": [
        "Sinais premium de trading",
        "Auto-trading avançado",
        "Suporte VIP",
        "Insights exclusivos do mercado",
        "Estratégias personalizadas"
      ]
    },
    "activate": "Ativar",
    "current": "Atual",
    "paymentRequired": "Pagamento Necessário",
    "nftRequired": "NFT Necessário",
    "membershipStatus": "Status da Assinatura",
    "active": "Ativo",
    "expired": "Expirado",
    "daysRemaining": "Dias restantes",
    "expiresOn": "Expira em",
  },
  "apiCredentials": {
    "title": "Credenciais API",
    "description": "Gerencie suas credenciais API de exchange para trading",
    "addCredentials": "Adicionar Credenciais API",
    "exchange": "Exchange",
    "exchanger": "Exchanger",
    "apiKey": "Chave API",
    "apiSecret": "Segredo API",
    "secretKey": "Chave Secreta",
    "passphrase": "Frase-senha",
    "testConnection": "Testar Conexão",
    "save": "Salvar Credenciais",
    "edit": "Editar",
    "delete": "Excluir",
    "status": "Status",
    "connected": "Conectado",
    "disconnected": "Desconectado",
    "invalid": "Inválido",
    "active": "Ativo",
    "testing": "Testando...",
    "connectionSuccess": "Conexão bem-sucedida",
    "connectionFailed": "Conexão falhada",
    "credentialsAdded": "Credenciais API adicionadas com sucesso",
    "credentialsUpdated": "Credenciais API atualizadas com sucesso",
    "credentialsDeleted": "Credenciais API excluídas com sucesso",
    "credentialAddedLimitReached": "Credencial adicionada (limite atingido)",
    "requiredMarketType": "Tipo de Mercado Obrigatório",
    "connectedTo": "Conectado a",
    "connectionNeedsAttention": "Conexão com",
    "needsAttention": "precisa de atenção",
    "lastUpdated": "Última atualização",
    "updateCredentialsMessage": "Por favor atualize suas credenciais API para continuar trading",
    "disconnect": "Desconectar",
    "disconnecting": "Desconectando...",
    "setAsActive": "Definir como Ativo",
    "activating": "Ativando...",
    "autoTrading": "Trading Automático",
    "enableAutoTradingDesc": "Habilitar trading automatizado para esta exchange",
    "tier2LimitReached": "Limite do Nível 2 atingido: até duas credenciais CEX permitidas.",
    "add": "Adicionar",
    "update": "Atualizar",
    "connectionValidated": "Conexão validada!",
    "autoTradingStatusChanged": "O trading automático foi",
    "marketTypes": {
      "futures": "Futuros",
      "spot": "Spot",
      "binanceNote": "Trading de futuros - alavancagem até 125x disponível",
      "binanceUsNote": "Trading spot com margem - alavancagem até 3x disponível",
      "krakenNote": "Trading de futuros - alavancagem até 100x disponível",
      "bybitNote": "Trading de futuros - alavancagem até 100x disponível",
      "hyperliquidNote": "Trading de futuros perpétuos - alavancagem até 50x disponível",
      "standardNote": "Trading spot padrão",
    },
    "errors": {
      "loadFailed": "Falha ao carregar credenciais",
      "keysRequired": "Chave API e Chave Secreta são obrigatórias",
      "tierUndetermined": "Não foi possível determinar o nível do usuário",
      "tier1Limit": "Nível 1 permite apenas uma credencial API",
      "tier2PerCex": "Nível 2 permite apenas uma credencial por CEX",
      "tier2Limit": "Nível 2 permite até duas credenciais (uma por CEX)",
      "tier3Limit": "Nível 3 permite apenas uma credencial para todas as CEXs",
      "saveFailed": "Falha ao salvar",
      "validationFailed": "Validação falhada",
      "activationFailed": "Ativação falhada",
      "deactivationFailed": "Desativação falhada",
      "noCredentials": "Nenhuma credencial encontrada para esta exchange",
      "autoTradingUpdateFailed": "Falha na Atualização do Trading Automático",
      "autoTradingUpdateFailedDesc": "Falha ao atualizar configurações de trading automático",
    },
    "success": {
      "credentialsSaved": "Credenciais salvas",
      "connectionSuccessful": "Conexão bem-sucedida",
      "activated": "Ativado",
      "deactivated": "Desativado",
      "autoTradingEnabled": "Trading Automático Habilitado",
      "autoTradingDisabled": "Trading Automático Desabilitado",
    }
  },
  "referrals": {
    "title": "Painel de Indicações",
    "loading": "Carregando painel de indicações...",
    "referralLink": "Link de Indicação",
    "referralLinkDescription": "Compartilhe este link para ganhar {{rate}}% dos pagamentos de participação nos lucros de suas indicações.",
    "tierNames": {
      "tier1": "Nível 1",
      "tier2": "Nível 2",
      "tier3": "Nível 3"
    },
    "settings": {
      "title": "Configurações",
      "referralSettings": "Configurações de Indicação",
      "solanaWalletAddress": "Endereço da Carteira Solana",
      "walletPlaceholder": "Digite o endereço da sua carteira Solana para pagamentos",
      "minimumPayoutAmount": "Valor Mínimo de Pagamento ($)",
      "enableAutomaticPayments": "Habilitar pagamentos automáticos",
      "autoPaymentEnabled": "Quando habilitado, você receberá automaticamente os pagamentos de indicação quando vencerem.",
      "autoPaymentDisabled": "Quando desabilitado, você não receberá nenhum pagamento de indicação até que isso seja habilitado novamente.",
      "saveSettings": "Salvar Configurações",
      "importantWarning": "Aviso Importante:",
      "warnings": {
        "ensureCorrectAddress": "Por favor, certifique-se de que o endereço da sua carteira Solana esteja correto",
        "doubleCheckAddress": "Verifique duas vezes o endereço antes de salvar",
        "notResponsible": "A DeepTrade NÃO é responsável por pagamentos enviados para endereços incorretos ou inválidos",
        "cannotRecover": "Fundos perdidos devido a endereços incorretos não podem ser recuperados"
      },
      "minimumPayoutRequirements": "Requisitos de Pagamento Mínimo:",
      "requirements": {
        "minimumAmount": "Valor mínimo de pagamento: $10.00 USDT",
        "gasFeeDeducted": "As taxas de gas da rede Solana serão deduzidas do pagamento",
        "estimatedGasFee": "Taxa de gas estimada: ~0.001 SOL (~$0.10-$0.50)",
        "payoutsProcessed": "Os pagamentos são processados em USDT na rede Solana"
      }
    },
    "overview": {
      "totalReferrals": "Total de Indicações",
      "activeCount": "{{count}} ativos",
      "totalEarnings": "Ganhos Totais",
      "totalPaid": "${{amount}} pagos",
      "pendingPayout": "Pagamento Pendente",
      "requestPayout": "Solicitar Pagamento",
      "earningRate": "Taxa de Ganhos"
    },
    "actions": {
      "copy": "Copiar",
      "generateNew": "Gerar Novo"
    },
    "recentActivity": {
      "recentReferrals": "Indicações Recentes",
      "recentEarnings": "Ganhos Recentes",
      "noReferrals": "Ainda não há indicações. Comece a compartilhar seu link!",
      "noEarnings": "Ainda não há ganhos. As indicações precisam começar a fazer trading!",
      "earned": "${{amount}} ganhos"
    },
    "status": {
      "verified": "Verificado",
      "pending": "Pendente",
      "paid": "Pago"
    },
    "messages": {
      "copied": "Copiado!",
      "linkCopied": "Link de indicação copiado para a área de transferência",
      "newCodeGenerated": "Novo código de indicação gerado",
      "profileUpdated": "Perfil atualizado com sucesso",
      "payoutRequestSubmitted": "Solicitação de pagamento enviada"
    },
    "errors": {
      "failedToLoadData": "Falha ao carregar dados de indicações",
      "failedToGenerateCode": "Falha ao gerar novo código",
      "invalidMinimumPayout": "Pagamento Mínimo Inválido",
      "minimumPayoutRequired": "O pagamento mínimo deve ser pelo menos $10.00",
      "invalidWalletAddress": "Endereço de Carteira Inválido",
      "validWalletRequired": "Por favor, digite um endereço de carteira Solana válido",
      "failedToUpdateProfile": "Falha ao atualizar perfil",
      "failedToRequestPayout": "Falha ao solicitar pagamento"
    }
  },

  "paperTradingHelp": {
    "title": "Guia do Trading de Simulação",
    "whatIsPaperTrading": "O que é Trading de Simulação?",
    "whatIsPaperTradingDesc": "O trading de simulação é um ambiente de trading simulado que permite praticar estratégias de trading usando dinheiro virtual em vez de fundos reais. É a maneira perfeita de testar nosso sistema de trading com IA sem nenhum risco financeiro.",
    "keyBenefits": "Principais Benefícios",
    "riskFree": "Aprendizado Sem Risco",
    "riskFreeDesc": "Pratique com fundos virtuais - sem dinheiro real em risco",
    "realMarketData": "Dados de Mercado Reais",
    "realMarketDataDesc": "Experimente condições de mercado ao vivo e movimentos de preços",
    "aiTradingSystem": "Sistema de Trading com IA",
    "aiTradingSystemDesc": "Teste nossos sinais avançados de IA em um ambiente seguro",
    "buildConfidence": "Construa Confiança",
    "buildConfidenceDesc": "Desenvolva suas habilidades de trading antes de usar dinheiro real",
    "howItWorks": "Como Funciona",
    "step1": "Alternar para Modo Simulação",
    "step1Desc": "Mude o interruptor do modo de trading para habilitar o trading de simulação",
    "step2": "Saldo Virtual",
    "step2Desc": "Comece com $10.000 de saldo virtual (pode ser redefinido)",
    "step3": "Sinais de IA",
    "step3Desc": "Nossa IA gera sinais de trading baseados em dados de mercado reais",
    "step4": "Negociações Simuladas",
    "step4Desc": "As negociações são executadas virtualmente - acompanhe seu desempenho",
    "importantNotes": "Notas Importantes",
    "noRealMoney": "Sem Dinheiro Real",
    "noRealMoneyDesc": "O trading de simulação usa apenas fundos virtuais. Não ocorrem lucros ou perdas reais.",
    "noRealFees": "Sem Taxas Reais",
    "noRealFeesDesc": "Taxas de trading e deslizamento são simulados para uma experiência realista.",
    "performanceTracking": "Acompanhamento de Desempenho",
    "performanceTrackingDesc": "Todas as estatísticas e análises são baseadas apenas em negociações simuladas.",
    "readyToStart": "Pronto para Começar?",
    "readyToStartDesc": "Mude o interruptor \"Modo de Trading\" para \"Simulação\" e comece a praticar com fundos virtuais hoje!",
    "buildConfidenceFooter": "💪 Construa confiança com o trading de simulação antes de arriscar dinheiro real!",
    "resetModal": {
      "title": "Redefinir Conta de Trading de Simulação",
      "warning": "Aviso: Esta ação não pode ser desfeita",
      "warningDesc": "Isso excluirá permanentemente todo o seu histórico de trading de simulação e redefinirá seu saldo virtual.",
      "resetLimitReached": "Limite Diário de Redefinição Atingido",
      "resetLimitReachedDesc": "Você usou todas as 3 redefinições para hoje. O limite é redefinido à meia-noite UTC.",
      "resetsRemaining": "Redefinições restantes hoje: {{count},",
      "currentBalance": "Saldo Atual: ${{balance},",
      "resetToDefault": "Redefinir para $10.000 padrão",
      "customBalance": "Definir saldo personalizado",
      "customBalanceDesc": "Digite um saldo inicial personalizado (mínimo $1.000)",
      "confirmationRequired": "Digite 'RESET' para confirmar",
      "confirmationPlaceholder": "Digite RESET aqui...",
      "confirmationRequiredError": "Por favor digite 'RESET' para confirmar",
      "invalidBalance": "Saldo Inválido",
      "invalidBalanceDesc": "Por favor digite um valor de saldo positivo válido",
      "resetting": "Redefinindo...",
      "resetButton": "Redefinir Conta",
    },
    "howItWorksModal": {
      "title": "Como Funciona o Trading de Simulação",
      "step1": "Comece com $10.000 de saldo virtual (configurável)",
      "step2": "Habilite o trading automático para que a IA execute negociações automaticamente",
      "step3": "Monitore o desempenho e ajuste as configurações de risco conforme necessário",
      "step4": "Mude para o trading ao vivo quando estiver confiante no sistema",
    },
    "importantNotesDetails": {
      "noRealMoneyTitle": "Sem Dinheiro Real:",
      "noRealMoneyDesc": "O trading de simulação usa apenas fundos virtuais. Não ocorrem lucros ou perdas reais.",
      "noFeesTitle": "Sem Taxas:",
      "noFeesDesc": "O trading de simulação não gera taxas de participação nos lucros, pois não são obtidos lucros reais.",
      "resetLimitTitle": "Limite de Redefinição:",
      "resetLimitDesc": "Você pode redefinir sua conta de simulação até 3 vezes por dia.",
    },
    "benefits": {
      "title": "Benefícios do Trading de Simulação",
      "riskFreeLearning": "Aprendizado Sem Risco",
      "riskFreeLearningDesc": "Pratique sem perder dinheiro real enquanto aprende como nosso sistema de IA funciona",
      "strategyTesting": "Teste de Estratégias",
      "strategyTestingDesc": "Teste diferentes configurações de risco e veja como elas funcionam ao longo do tempo",
      "realMarketData": "Dados de Mercado Reais",
      "realMarketDataDesc": "Usa preços de mercado ao vivo e previsões de ML reais para uma experiência autêntica",
    },
    "gettingStarted": {
      "title": "Pronto para Começar?",
      "description": "Alterne o interruptor \"Modo de Trading\" para \"Simulação\" e comece a praticar com fundos virtuais hoje!",
      "buildConfidenceFooter": "💪 Construa confiança com o trading de simulação antes de arriscar dinheiro real!",
    },
    "perfectForBeginners": "💡 Perfeito para iniciantes e traders experientes que querem testar novas estratégias!",
    "availableToAllTitle": "Disponível para Todos:",
    "availableToAllDesc": "O trading de simulação está disponível para todos os usuários independentemente do nível de tier.",
    "gotItThanks": "Entendi, obrigado!",
  },

  "paperTradingDashboard": {
    "performance": {
      "title": "Desempenho do Trading de Simulação",
      "refresh": "Atualizar",
      "reset": "Redefinir",
      "totalReturn": "Retorno Total",
    },

    "errors": {
      "loadFailed": "Falha ao carregar dados do trading de simulação",
    }
  },
  "tradingSignalStatus": {
    "title": "Status do Sinal de Trading",
    "description": "Status ao vivo da transmissão de sinais do sistema",
    "signalLabel": "Sinal",
    "confidenceLabel": "Confiança do Sinal de IA",
    "lastUpdateLabel": "Últ. atualização",
    "errorLoading": "Falha ao carregar o status de trading",
    "signals": {
      "HOLD": "MANTER",
      "BUY": "COMPRAR",
      "SELL": "VENDER",
      "LONG": "Longo",
      "SHORT": "Curto",
      "long": "Longo",
      "short": "Curto"
    }
  },
  "tier": {
    "choosePlan": "Escolha Seu Plano",
    "membershipStatus": {
      "title": "Status da Assinatura",
      "active": "Ativo",
      "expired": "Expirado",
      "daysRemaining": "Dias restantes:",
      "expiresOn": "Expira em:"
    },
    "modals": {
      "activateTier": "Ativar Nível {{tierName}}",
      "confirmActivation": "Tem certeza de que deseja ativar o nível {{tierName}}?",
      "confirmTierChange": "Confirmar Mudança de Nível",
      "confirmSwitch": "Tem certeza de que deseja mudar para o nível {{tierName}}?",
      "cancel": "Cancelar",
      "activate": "Ativar",
      "confirm": "Confirmar"
    },
    "tiers": {
      "starter": {
        "name": "Nível 1: Iniciante",
        "price": "Grátis",
        "description": "Perfeito para começar",
        "features": [
          "Sinais de Trading Básicos",
          "Alavancagem de Trading até 2.5x",
          "Limitado a Um Acesso API",
          "40% de Taxa de Participação nos Lucros"
        ]
      },
      "pro": {
        "name": "Nível 2: Pro",
        "description": "Para traders sérios",
        "accessInstructions": "Para acessar este nível, use o botão da carteira na barra de navegação superior para conectar sua carteira Solana e pagar por acesso de 30 dias.",
        "features": [
          "Sinais de Trading Avançados",
          "Alavancagem de Trading até 5x",
          "Limitado a Dois Acessos API",
          "20% de Taxa de Participação nos Lucros"
        ]
      },
      "nftElite": {
        "name": "Nível 3: NFT Elite",
        "price": "Vitalício",
        "description": "Para colecionadores verificados de NFT Capitolchilax.",
        "visitWebsite": "Visite capitolchilax.com",
        "accessInstructions": "Para acessar este nível, use o botão da carteira na barra de navegação superior para conectar e verificar sua elegibilidade NFT.",
        "features": [
          "Sinais de Trading Avançados",
          "Alavancagem de Trading até 10x",
          "Conexões API Ilimitadas",
          "10% de Taxa de Participação nos Lucros",
          "Sem Taxa de Assinatura Mensal"
        ]
      }
    },
    "status": {
      "currentTier": "Nível Atual",
      "alreadyUnlocked": "Já Desbloqueado",
      "yourCurrentTier": "Seu Nível Atual",
      "currentlyOn": "Você está atualmente em {{tierName}}"
    },
    "buttons": {
      "paymentRequired": "Pagamento Necessário",
      "connectWallet": "Conectar Carteira",
      "nftRequired": "NFT Necessário",
      "select": "Selecionar {{tierName}}",
      "activate": "Ativar {{tierName}}",
      "payToReactivate": "Pagar para Reativar",
      "payWithToken": "Pagar com {{token}}",
      "connectWalletFirst": "Conectar Carteira Primeiro",
      "proceedWithPayment": "Prosseguir com Pagamento"
    },
    "nft": {
      "verifyingOwnership": "Verificando propriedade do NFT...",
      "nftRequired": "Você precisa possuir um NFT específico para acessar este nível",
      "nftOwned": "Você possui um NFT da coleção necessária."
    },
    "payment": {
      "thirtyDaysAccess": "Acesso de 30 Dias",
      "thirtyDaysAccessDue": "Acesso de 30 Dias Vencido",
      "paymentDetails": "Detalhes do Pagamento",
      "amount": "Quantia:",
      "network": "Rede:",
      "wallet": "Carteira:",
      "connectionStatus": "Status da Conexão:",
      "connected": "Conectado",
      "disconnected": "Desconectado",
      "processing": "Processando Pagamento",
      "processingDescription": "Por favor confirme a transação em sua carteira e aguarde a confirmação...",
      "successful": "Pagamento Bem-sucedido!",
      "successDescription": "Seu pagamento foi processado com sucesso. Seu nível será atualizado em breve.",
      "failed": "Pagamento Falhou",
      "failedDescription": "Houve um erro ao processar seu pagamento. Por favor tente novamente.",
      "tryAgain": "Tentar Novamente",
      "thirtyDaysAccessDescription": "Complete seu pagamento para acesso de 30 dias para ativar recursos Pro.",
      "importantNotes": "Notas Importantes",
      "paymentWarnings": [
        "Certifique-se de ter {{token}} suficiente em sua carteira",
        "Mantenha algum SOL para taxas de transação (~0.001 SOL)",
        "O pagamento será processado na rede principal Solana",
        "A transação é irreversível uma vez confirmada"
      ]
    },
    "paymentHistory": {
      "title": "Histórico de Pagamentos",
      "profitShare": "Participação nos Lucros",
      "thirtyDaysAccess": "Acesso de 30 Dias",
      "billingPeriod": "${{amount}} vence para {{startDate}} - {{endDate}}"
    },
    "errors": {
      "paymentRequired": "Você deve pagar suas taxas pendentes de participação nos lucros (${{amount}}) antes de mudar de nível.",
      "downgradeNotAllowed": "Você não pode fazer downgrade do Nível {{currentTier}} para o Nível {{newTier}}. Você só pode fazer upgrade para níveis superiores.",
      "downgradeNotAllowedTitle": "Downgrade Não Permitido",
      "walletConnectionRequired": "Por favor conecte sua carteira Solana para acessar o Nível 2.",
      "walletConnectionRequiredTitle": "Conexão de Carteira Necessária",
      "nftRequired": "Você precisa possuir um NFT específico para acessar este nível.",
      "membershipExpired": "Sua assinatura do Nível 2 expirou. Você foi rebaixado para o nível Iniciante.",
      "membershipExpiredTitle": "Assinatura Expirada",
      "walletDisconnected": "Seu status de nível foi preservado.",
      "walletDisconnectedTitle": "Carteira Desconectada",
      "walletDisconnectedWithDays": "Seu acesso ao Nível 2 permanece ativo por mais {{days}} dias.",
      "couldNotValidate": "Seu status de nível foi preservado. Reconecte sua carteira para fazer pagamentos.",
      "failedToFetchTier": "Falha ao buscar status do nível",
      "errorLoadingTier": "Erro ao carregar informações do nível",
      "dataFetchError": "Falha ao buscar dados do nível: {{error}}",
      "dataFetchErrorTitle": "Erro de Busca de Dados",
      "walletNotConnected": "Por favor conecte sua carteira Solana para prosseguir com o pagamento.",
      "walletNotConnectedTitle": "Carteira Não Conectada",
      "paymentFailed": "Houve um erro ao processar seu pagamento. Por favor tente novamente.",
      "paymentSuccessful": "Seu pagamento de {{type}} foi processado com sucesso!",
      "activationFailed": "Falha ao ativar nível. Por favor tente novamente."
    },
    "profitShare": {
      "paymentDueTitle": "Pagamento de Participação nos Lucros Vencido",
      "accountDisabled": "Conta Desabilitada",
      "status": "Status de Participação nos Lucros",
      "paymentWasDue": "Pagamento venceu:",
      "paymentDue": "Pagamento vence:",
      "nextPaymentDeadline": "Próximo prazo de pagamento:",
      "payNow": "Pagar Agora",
      "payToReactivate": "Pagar para Reativar",
      "overdue": "VENCIDO",
      "accountDisabledMessage": "Conta Desabilitada - Pagamento Necessário",
      "paymentOverdue": "Pagamento Vencido",
      "paymentDueSoon": "Pagamento Vence Em Breve",
      "wasDue": "Venceu:",
      "due": "Vence:",
      "youOwe": "Você deve ${{amount}} em taxas de participação nos lucros",
      "allCaughtUp": "Sem taxas pendentes de participação nos lucros - Você está em dia! 🎉",
      "scheduleInfo": "Pagamentos de participação nos lucros vencem todo sábado às 0:00 GMT",
      "disableWarning": "Contas são desabilitadas todo sábado às 0:00 GMT por taxas não pagas",
      "deadlineApproaching": "Prazo de Pagamento Aproximando",
      "deadlineMessage": "Seu pagamento de participação nos lucros de ${{amount}} vence no sábado às 0:00 GMT. Sua conta será automaticamente desabilitada se o pagamento não for recebido até o prazo.",
      "accountTradingDisabled": "Trading da Conta Desabilitado",
      "accountDisabledDescription": "Sua conta de trading está desabilitada devido a taxas pendentes de participação nos lucros. Pague ${{amount}} para reativar o trading.",
      "accountSuspendedWarning": "⚠️ Sua conta foi desabilitada devido a taxas não pagas. O trading está suspenso até que o pagamento seja feito.",
      "disabledOn": "Desabilitada em:",
      "deadline": "Prazo:"
    },
    "coupon": {
      "redeemButton": "Tem um Cupom? Resgate Aqui",
      "redeemDescription": "Atualize seu nível instantaneamente com um código de cupom"
    },
    "pricing": {
      "free": "Grátis",
      "lifetime": "Vitalício",
      "thirtyDayAccess": "${{price}} para acesso de 30 dias"
    },
    "success": {
      "tierUpdated": "Seu nível foi atualizado para {{tierName}}.",
      "tierActivated": "Seu nível foi atualizado com sucesso.",
      "paymentSuccessful": "Seu pagamento de {{type}} foi processado com sucesso!"
    },
    "notifications": {
      "accountDisabled": {
        "title": "🚫 Conta Desabilitada",
        "description": "Sua conta foi desabilitada devido a taxas não pagas de participação nos lucros de ${{amount}}. Por favor faça um pagamento para reativar sua conta."
      },
      "paymentOverdue": {
        "title": "⚠️ Pagamento Vencido",
        "description": "Seu pagamento de participação nos lucros de ${{amount}} está vencido. Sua conta pode ser desabilitada em breve."
      },
      "paymentReminder": {
        "title": "⏰ Lembrete de Pagamento",
        "description": "Seu pagamento de participação nos lucros de ${{amount}} vence no sábado 0:00 GMT. Por favor pague para evitar suspensão da conta."
      }
    }
  },
  "help": {
    "title": "Ajuda e Suporte",
    "description": "Encontre respostas para perguntas comuns, revise nossas políticas legais e entre em contato com nossa equipe de suporte.",
    "faqTab": "Perguntas Frequentes",
    "legalTab": "Legal",
    "contactTab": "Contato",
    "faqSection": {
      "categories": {
        "general": "Geral",
        "trading": "Trading",
        "tiers": "Níveis",
        "setup": "Configuração",
        "security": "Segurança",
        "billing": "Faturamento"
      },
      "items": {
        "whatIsDeepTrade": {
          "question": "O que é o DeepTrade?",
          "answer": "DeepTrade é uma plataforma de trading de criptomoedas alimentada por IA que fornece sinais de trading automatizados e ferramentas de gestão de portfólio usando algoritmos avançados de aprendizado de máquina."
        },
        "howSignalsWork": {
          "question": "Como funcionam os sinais de trading?",
          "answer": "Nossa IA analisa dados de mercado em tempo real para gerar sinais de compra/venda com pontos de entrada, stop losses e níveis de take profit. Você pode executá-los manualmente ou habilitar o auto-trading."
        },
        "tierLevels": {
          "question": "Quais são os diferentes níveis de tier?",
          "answer": "Tier 1 (Grátis): Sinais básicos. Tier 2 ($50/mês): Sinais avançados + auto-trading. Tier 3 (NFT necessário): Recursos premium + suporte prioritário."
        },
        "connectExchange": {
          "question": "Como conectar minha conta de exchange?",
          "answer": "Vá para Credenciais API no seu dashboard, adicione suas chaves API do exchange (recomendado somente leitura), e nosso sistema validará a conexão."
        },
        "dataSecure": {
          "question": "Meus dados estão seguros?",
          "answer": "Sim, usamos criptografia padrão da indústria, nunca armazenamos suas chaves privadas, e recomendamos acesso API somente leitura para máxima segurança."
        },
        "profitShares": {
          "question": "Como funcionam as participações nos lucros?",
          "answer": "Para usuários Tier 2+, cobramos uma pequena porcentagem dos lucros gerados através de nossos sinais. Isso alinha nossos interesses com seu sucesso."
        },
        "cancelSubscription": {
          "question": "Posso cancelar minha assinatura a qualquer momento?",
          "answer": "Sim, você pode fazer downgrade ou cancelar sua assinatura a qualquer momento. Você manterá o acesso até o final do seu período de faturamento atual."
        },
        "supportedExchanges": {
          "question": "Quais exchanges são suportadas?",
          "answer": "Atualmente suportamos as principais exchanges incluindo Binance, Coinbase Pro, Kraken, e outras. Verifique nossa página de Credenciais API para a lista completa."
        }
      }
    },
    "legal": {
      "documents": "Documentos Legais",
      "englishNotice": "Sempre exibido em inglês para clareza legal",
      "privacy": {
        "title": "Política de Privacidade",
        "description": "Nossa Política de Privacidade descreve como coletamos, usamos e protegemos suas informações pessoais quando você usa os serviços do DeepTrade. Estamos comprometidos em manter a privacidade e segurança dos seus dados.",
        "highlights": {
          "title": "Destaques Principais de Privacidade:",
          "item1": "Coletamos apenas informações necessárias para fornecer nossos serviços",
          "item2": "Seus dados de trading são criptografados e armazenados com segurança",
          "item3": "Nunca vendemos suas informações pessoais para terceiros",
          "item4": "Você tem controle sobre seus dados e configurações de privacidade"
        },
        "viewFull": "Ver Política de Privacidade Completa"
      },
      "terms": {
        "title": "Termos de Serviço",
        "description": "Nossos Termos de Serviço regem o uso da plataforma e serviços do DeepTrade. Ao usar nossa plataforma, você concorda com estes termos e condições.",
        "highlights": {
          "title": "Destaques Principais dos Termos:",
          "item1": "Direitos e restrições de uso da plataforma",
          "item2": "Responsabilidades e obrigações do usuário",
          "item3": "Disponibilidade e limitações do serviço",
          "item4": "Políticas de encerramento e suspensão de conta"
        },
        "viewFull": "Ver Termos de Serviço Completos"
      },
      "risks": {
        "title": "Divulgação de Riscos"
      }
    },
    "contact": {
      "title": "Contatar Suporte",
      "form": {
        "name": "Nome",
        "email": "Email",
        "subject": "Assunto",
        "message": "Mensagem",
        "sendMessage": "Enviar Mensagem",
        "sending": "Enviando...",
        "placeholders": {
          "name": "Seu nome completo",
          "email": "seu.email@exemplo.com",
          "subject": "Breve descrição do seu problema",
          "message": "Por favor, descreva seu problema em detalhes..."
        }
      },
      "guidelines": {
        "title": "Diretrizes de Suporte",
        "before": {
          "title": "Antes de Contatar o Suporte",
          "item1": "Verifique esta seção de FAQ primeiro",
          "item2": "Revise as configurações da sua conta",
          "item3": "Verifique suas credenciais API",
          "item4": "Verifique nossa página de status para problemas conhecidos"
        },
        "when": {
          "title": "Ao Contatar o Suporte",
          "item1": "Inclua o email da sua conta",
          "item2": "Descreva o problema em detalhes",
          "item3": "Forneça capturas de tela se aplicável",
          "item4": "Inclua mensagens de erro"
        },
        "notice": {
          "title": "Aviso Importante",
          "message": "Nunca pediremos suas chaves privadas, senhas ou chaves secretas da API. Mantenha essas informações seguras e nunca as compartilhe com ninguém."
        }
      },
      "errors": {
        "missingInformation": "Informações Faltando",
        "fillAllFields": "Por favor, preencha todos os campos antes de enviar.",
        "failedToSend": "Falha ao enviar mensagem",
        "error": "Erro",
        "tryAgainLater": "Falha ao enviar mensagem. Tente novamente mais tarde."
      },
      "success": {
        "messageSent": "Mensagem Enviada!",
        "thankYou": "Obrigado por entrar em contato conosco. Responderemos dentro de 24-48 horas."
      }
    }
  },
  "redeemCoupon": {
    "title": "Resgatar Cupom",
    "subtitle": "Digite seu código de cupom para atualizar seu nível",
    "currentTier": "Nível Atual:",
    "couponCode": "Código do Cupom",
    "placeholder": "Digite o código do cupom (ex., DTABC123)",
    "formatHint": "O código deve ter 4-20 caracteres, apenas letras e números",
    "redeemButton": "Resgatar Cupom",
    "redeeming": "Resgatando...",
    "backToTier": "← Voltar ao Gerenciamento de Níveis",
    "tierNames": {
      "starter": "Iniciante (Grátis)",
      "pro": "Pro (Premium)",
      "vip": "VIP (Elite)",
      "unknown": "Desconhecido"
    },
    "howItWorks": {
      "title": "Como funciona:",
      "steps": [
        "Digite seu código de cupom acima",
        "Seu nível será atualizado automaticamente",
        "Você terá acesso imediato a novos recursos",
        "Cada cupom só pode ser usado uma vez"
      ]
    },
    "errors": {
      "invalidInput": "Entrada Inválida",
      "enterCouponCode": "Por favor, digite um código de cupom",
      "invalidFormat": "Formato Inválido",
      "formatRequirement": "O código do cupom deve ter 4-20 caracteres, apenas letras e números",
      "redemptionFailed": "Resgate Falhou",
      "failedToRedeem": "Falha ao resgatar cupom",
      "networkError": "Erro de Rede",
      "connectionFailed": "Falha ao conectar com o servidor. Tente novamente."
    },
    "success": {
      "redeemed": "Cupom Resgatado com Sucesso!",
      "validFor": "(Válido por {{days}} dias)"
    }
  },
  "oauthCallback": {
    "loading": {
      "title": "Autenticando...",
      "description": "Por favor aguarde enquanto completamos sua autenticação."
    },
    "error": {
      "title": "Erro de Autenticação",
      "returnToLogin": "Voltar ao Login",
      "tryAgain": "Tentar Novamente"
    },
    "completing": {
      "title": "Completando Autenticação",
      "description": "Por favor aguarde enquanto fazemos seu login..."
    },
    "errors": {
      "authenticationFailed": "Falha na autenticação",
      "noAuthorizationCode": "Nenhum código de autorização recebido do provedor OAuth",
      "invalidServerResponse": "Resposta inválida do servidor",
      "unexpectedError": "Ocorreu um erro inesperado durante a autenticação",
      "noAdditionalDetails": "Nenhum detalhe adicional disponível"
    }
  },
  "resetPassword": {
    "validation": {
      "minLength": "A senha deve ter pelo menos 8 caracteres",
      "uppercase": "A senha deve conter pelo menos uma letra maiúscula",
      "lowercase": "A senha deve conter pelo menos uma letra minúscula",
      "number": "A senha deve conter pelo menos um número",
      "specialChar": "A senha deve conter pelo menos um caractere especial"
    },
    "errors": {
      "invalidToken": "Token Inválido",
      "invalidTokenDescription": "Este link de redefinição de senha é inválido ou expirou.",
      "validationFailed": "Validação Falhou",
      "validationFailedDescription": "Falha ao validar o token de redefinição. Tente novamente.",
      "fillAllFields": "Por favor preencha todos os campos",
      "passwordsDoNotMatch": "As senhas não coincidem",
      "requirementsNotMet": "Requisitos de Senha Não Atendidos",
      "resetFailed": "Falha ao redefinir senha",
      "resetFailedTitle": "Redefinição Falhou"
    },
    "success": {
      "title": "Redefinição de Senha Bem-sucedida",
      "description": "Sua senha foi atualizada com sucesso.",
      "passwordUpdated": "✓ Senha Atualizada",
      "securityNote": "Agora você pode fazer login com sua nova senha. Por segurança, você foi desconectado de todos os dispositivos.",
      "continueToLogin": "Continuar para Login"
    },
    "validating": {
      "title": "Validando Link de Redefinição",
      "description": "Aguarde enquanto validamos seu link de redefinição de senha..."
    },
    "invalid": {
      "title": "Link de Redefinição Inválido",
      "description": "Este link de redefinição de senha é inválido ou expirou.",
      "linkInvalid": "Link Inválido",
      "reason1": "• O link de redefinição pode ter expirado (links expiram após 1 hora)",
      "reason2": "• O link pode já ter sido usado",
      "reason3": "• O link pode estar malformado ou incompleto",
      "requestNewLink": "Solicitar Novo Link de Redefinição",
      "backToLogin": "Voltar ao Login"
    },
    "form": {
      "title": "Redefinir Sua Senha",
      "description": "Digite sua nova senha para {{email}}",
      "newPassword": "Nova Senha",
      "newPasswordPlaceholder": "Digite sua nova senha",
      "confirmPassword": "Confirmar Nova Senha",
      "confirmPasswordPlaceholder": "Confirme sua nova senha",
      "updating": "Atualizando Senha...",
      "updateButton": "Atualizar Senha",
      "backToLogin": "Voltar ao Login"
    },
    "requirements": {
      "title": "Requisitos de Senha",
      "minLength": "• Pelo menos 8 caracteres",
      "caseLetters": "• Incluir letras maiúsculas e minúsculas",
      "number": "• Incluir pelo menos um número",
      "specialChar": "• Incluir pelo menos um caractere especial (!@#$%^&*(),.?\":{}|<>)"
    },
    "expiration": {
      "notice": "Este link de redefinição expira em {{time}}"
    }
  },
  "twoFAResetRequest": {
    "securityQuestions": {
      "question1": "Quando foi sua última negociação bem-sucedida?",
      "question2": "Em que nível você está atualmente (1, 2 ou 3)?",
      "question3": "Qual exchange você usa principalmente para negociar?"
    },
    "errors": {
      "fillRequiredFields": "Por favor preencha todos os campos obrigatórios (email, nome completo e motivo)",
      "submitFailed": "Falha ao enviar solicitação de redefinição 2FA",
      "requestFailed": "Solicitação Falhou"
    },
    "success": {
      "requestSubmitted": "Solicitação Enviada",
      "title": "Solicitação Enviada",
      "description": "Sua solicitação de redefinição 2FA foi enviada para análise.",
      "submittedSuccessfully": "✓ Solicitação Enviada com Sucesso",
      "email": "Email",
      "requestId": "ID da Solicitação",
      "status": "Status",
      "pendingReview": "Pendente de Análise",
      "whatHappensNext": "O que acontece agora?",
      "step1": "1. Nossa equipe de segurança analisará sua solicitação e informações de verificação",
      "step2": "2. Podemos contatá-lo para verificação adicional se necessário",
      "step3": "3. Você receberá uma notificação por email quando processada",
      "step4": "4. Se aprovada, seu 2FA será desabilitado e você poderá configurá-lo novamente",
      "backToLogin": "Voltar ao Login",
      "submitAnother": "Enviar Outra Solicitação"
    },
    "form": {
      "title": "Solicitação de Redefinição 2FA",
      "description": "Perdeu acesso ao seu dispositivo 2FA? Preencha este formulário para solicitar uma redefinição de nossa equipe de segurança.",
      "securityNotice": "⚠️ Aviso de Segurança Importante",
      "notice1": "• Este processo requer análise manual de nossa equipe de segurança",
      "notice2": "• Forneça informações o mais precisas possível para acelerar a verificação",
      "notice3": "• Informações falsas resultarão em rejeição da solicitação",
      "notice4": "• Tempo de processamento: 1-3 dias úteis",
      "requiredInformation": "Informações Obrigatórias",
      "emailAddress": "Endereço de Email *",
      "fullName": "Nome Completo *",
      "reason": "Motivo para Redefinição 2FA *",
      "additionalVerification": "Verificação Adicional (Opcional mas Recomendado)",
      "lastLoginDate": "Data Aproximada do Último Login",
      "accountCreationDate": "Data Aproximada de Criação da Conta",
      "recentActivity": "Atividade Recente da Conta",
      "securityQuestionsTitle": "Perguntas de Segurança",
      "securityQuestionsDescription": "Responda essas perguntas para ajudar a verificar sua identidade. Deixe em branco se não souber.",
      "submittingRequest": "Enviando Solicitação...",
      "submitButton": "Enviar Solicitação de Redefinição 2FA",
      "backToLogin": "Voltar ao Login",
      "rememberDevice": "Lembra do seu dispositivo 2FA?",
      "tryVerification": "Tentar verificação 2FA",
      "placeholders": {
        "email": "Digite o endereço de email da sua conta",
        "fullName": "Digite seu nome completo como registrado",
        "reason": "Explique por que precisa redefinir seu 2FA (ex., telefone perdido, dispositivo quebrado, etc.)",
        "lastLoginDate": "ex., 15 de dezembro, 2024",
        "accountCreationDate": "ex., novembro 2024",
        "recentActivity": "Descreva atividades recentes (negociações, mudanças de nível, pagamentos, etc.)",
        "yourAnswer": "Sua resposta"
      }
    }
  },
  "verify2FA": {
    "title": "Autenticação de Dois Fatores",
    "description": "Um código de verificação de 6 dígitos foi enviado para seu endereço de email",
    "form": {
      "verificationCode": "Código de Verificação",
      "placeholder": "Digite código de 6 dígitos",
      "verifying": "Verificando...",
      "verifyCode": "Verificar Código"
    },
    "errors": {
      "sessionExpired": "Sessão Expirada",
      "pleaseLoginAgain": "Por favor faça login novamente.",
      "enterCode": "Por favor digite o código de verificação",
      "codeMustBe6Digits": "O código de verificação deve ter 6 dígitos",
      "verificationFailed": "Verificação falhou",
      "verificationFailedTitle": "Verificação Falhou",
      "invalidCode": "Código de verificação inválido",
      "failedToResendCode": "Falha ao reenviar código",
      "failedToResendTitle": "Falha ao Reenviar"
    },
    "success": {
      "loginSuccessful": "Login Bem-sucedido",
      "welcomeBack": "Bem-vindo de volta!",
      "codeSent": "Código Enviado",
      "codeSentDescription": "Um novo código de verificação foi enviado para seu email."
    },
    "help": {
      "needHelp": "Precisa de ajuda?",
      "sending": "Enviando...",
      "resendCode": "Reenviar Código",
      "backToLogin": "Voltar ao Login",
      "lostDevice": "Perdeu o Dispositivo 2FA? Solicitar Redefinição",
      "didntReceiveCode": "Não recebeu o código? Verifique sua pasta de spam ou",
      "resendIt": "reenvie",
      "byContinuing": "Ao continuar, você concorda com nossos",
      "termsOfService": "Termos de Serviço",
      "privacyPolicy": "Política de Privacidade"
    }
  },
  "forgotPassword": {
    "errors": {
      "emailRequired": "Endereço de email é obrigatório",
      "sendFailed": "Falha ao enviar email de redefinição de senha",
      "requestFailed": "Solicitação Falhou"
    },
    "success": {
      "emailSent": "Email de Redefinição Enviado",
      "title": "Verifique Seu Email",
      "description": "Se uma conta com este email existir, você receberá um link de redefinição de senha.",
      "emailSentTitle": "Email Enviado",
      "emailSentMessage": "Enviamos um link de redefinição de senha para {{email}} se uma conta existir.",
      "instruction1": "• Verifique sua pasta de spam/lixo eletrônico se não vir o email",
      "instruction2": "• O link de redefinição expira em 1 hora",
      "instruction3": "• Você pode solicitar outra redefinição se necessário",
      "sendAnother": "Enviar Outro Email de Redefinição",
      "backToLogin": "Voltar ao Login"
    },
    "form": {
      "title": "Esqueci a Senha",
      "description": "Digite seu endereço de email e enviaremos um link para redefinir sua senha.",
      "emailAddress": "Endereço de Email",
      "placeholder": "Digite seu endereço de email",
      "sending": "Enviando...",
      "sendResetLink": "Enviar Link de Redefinição",
      "backToLogin": "Voltar ao Login",
      "noAccount": "Não tem uma conta?",
      "signUp": "Cadastre-se",
      "lost2FA": "Perdeu acesso ao seu dispositivo 2FA?",
      "request2FAReset": "Solicitar redefinição 2FA"
    },
    "security": {
      "title": "Nota de Segurança",
      "note1": "• A redefinição de senha está disponível apenas para contas tradicionais",
      "note2": "• Usuários do Google OAuth devem usar \"Entrar com Google\"",
      "note3": "• Links de redefinição expiram após 1 hora por segurança"
    }
  }
};
